var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"info",attrs:{"src":require("../../assets/images/nine-year/info2.png")}})])
}]

export { render, staticRenderFns }